import { CustomSelectFieldProps, SelectField } from 'components/form'

import { SimNaoEnum, simNaoEnumRecord } from '../SimNaoRadioGroupField'

type SimNaoSelectFieldProps = CustomSelectFieldProps<SimNaoEnum>

export function SimNaoSelectField(props: SimNaoSelectFieldProps) {
  return <SelectField<SimNaoEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.values(SimNaoEnum)

const itemToString = (item: SimNaoEnum) => simNaoEnumRecord[item]
